module.exports = __webpack_public_path__ + "img/result.e4e71db2.png";